/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_ContentInputs */

const vi_payment_qr_content = /** @type {(inputs: Payment_Qr_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung CK`)
};

/**

* @param {Payment_Qr_ContentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_content = /** @type {((inputs?: Payment_Qr_ContentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_ContentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_content(inputs)
});